/**
 * BrandingContext — laedt das systemweite White-Label-Branding (Logo + Firmenname)
 * und stellt es per Hook bereit. Spiegelt es zusaetzlich in den Modul-Cache
 * (lib/branding.js), damit synchrone PDF-Utils es lesen koennen.
 */
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../lib/axiosClient';
import { getBranding, setBranding as setBrandingCache, DEFAULT_COMPANY_NAME } from '../lib/branding';

const BrandingContext = createContext({
  branding: { companyName: DEFAULT_COMPANY_NAME, logoDataUrl: '', footerLine: '' },
  loading: true,
  refreshBranding: async () => {},
});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(getBranding());
  const [loading, setLoading] = useState(true);

  const refreshBranding = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/branding`);
      const cached = setBrandingCache(res.data || {});
      setBranding({ ...cached });
    } catch {
      // Nicht eingeloggt oder Fehler -> Default-Branding beibehalten.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshBranding();
    const onAuthReady = () => refreshBranding();
    window.addEventListener('qm8d:auth:ready', onAuthReady);
    return () => window.removeEventListener('qm8d:auth:ready', onAuthReady);
  }, [refreshBranding]);

  return (
    <BrandingContext.Provider value={{ branding, loading, refreshBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}

export default BrandingContext;
